import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../types/types';
import { IViewSettingsHOCProps } from './types';
import { onClickGroupByEpicsToggler } from './events/onClickGroupByEpicsToggler';
import { getGroupByEpics } from '../../selectors/getGroupByEpics';
import { IViewSettingsEvents, IViewSettingsFields } from '../../components/ViewSettings/types';
import { ViewSettings } from '../../components/ViewSettings/ViewSettings';
import { onClickGroupsCollapseToggler } from './events/onClickGroupsCollapseToggler';
import { getCollapsed } from '../../selectors/getCollapsed';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IViewSettingsHOCProps
): IViewSettingsFields => {
    return {
        isExpand: !getCollapsed(state, boardId),
        isGroupEpic: getGroupByEpics(state, boardId),
    }
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IViewSettingsHOCProps
): IViewSettingsEvents => {
    return {
        onToggleExpand: () => dispatch(onClickGroupsCollapseToggler(boardId)),
        onToggleGroupEpic: () => dispatch(onClickGroupByEpicsToggler(boardId)),
    }
};

export const ViewSettingsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewSettings);

ViewSettingsHOC.displayName = 'ViewSettingsHOC';
